import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export const getRequest = async (
  context: ServiceContext,
  url: string,
  config?: AxiosRequestConfig
) => {
  return await context.request.get(url, config);
};

export const postRequest = async (
  context: ServiceContext,
  url: string,
  data: any,
  config?: AxiosRequestConfig
) => {
  return await context.request.post(url, data, config);
};

export const deleteRequest = async (
  context: ServiceContext,
  url: string,
  config?: AxiosRequestConfig
) => {
  return await context.request.delete(url, config);
};

export const putRequest = async (
  context: ServiceContext,
  url: string,
  data: any,
  config?: AxiosRequestConfig
) => {
  return await context.request.put(url, data, config);
};

export const patchRequest = async (
  context: ServiceContext,
  url: string,
  data: any,
  config?: AxiosRequestConfig
) => {
  return await context.request.patch(url, data, config);
};

export class ServiceContext {
  request: AxiosInstance;
  constructor(url: string | undefined, config: AxiosRequestConfig) {
    const option = {
      ...config,
      baseURL: url
    };

    this.request = Axios.create(option);
  }
}
